import {createApp} from "vue/dist/vue.esm-bundler";
import {createRouter} from "vue-router/dist/vue-router.esm-bundler";
import {createWebHashHistory} from "vue-router/dist/vue-router.esm-bundler";

import SectionSummary from "./main/SectionSummary.vue";
import SectionIncome from "./main/SectionIncome.vue";
import SectionWithdrawals from "./main/SectionWithdrawals.vue";
import SectionFarmIncome from "./main/SectionFarmIncome.vue";
import SectionFarm from "./main/SectionFarm.vue";
import SectionFarmOrders from "./main/SectionFarmOrders.vue";
import SectionAccount from "./main/SectionAccount.vue";
import Withdrawal from "./main/include/Withdrawal.vue";

window['xive']['getUserData']((data) => {
  if (data == null) {
    document.location = '/' + window['CURRENT_LANGUAGE'];
    return;
  }

  const routes = [
    { path: '/', component: SectionSummary },
    { path: '/account', component: SectionAccount },
    { path: '/income', component: SectionIncome },
    { path: '/withdrawals', component: SectionWithdrawals },
    { path: '/farm/:farmId', component: SectionFarm, props: true },
    { path: '/farm/:farmId/income', component: SectionFarmIncome, props: true },
    { path: '/farm/:farmId/orders', component: SectionFarmOrders, props: true },
  ];

  const router = createRouter({
    history: createWebHashHistory(),
    routes
  });

  const app = createApp({
    components: {Withdrawal},
    template: "" +
      "<router-view></router-view>" +
      "<Withdrawal />"
  }, {});

  app.use(router);
  app.mount('#app-main');

  document.body.style.setProperty('--100vw', document.documentElement.clientWidth + 'px');
});